module.exports = __webpack_public_path__ + "components/flag/static/square/pn-252ef3059c1fcb6bb5629acf89923cef.svg";